/** CloudFront hostname → S3 bucket (path-style URLs required — bucket names contain dots). */
export const CLOUDFRONT_TO_S3_BUCKET: Record<string, string> = {
  'd3gijido82a16v.cloudfront.net': 'assets-s3.wideo.co',
  'd1xj354wx1cc8s.cloudfront.net': 'sounds.wideo.co',
  'd2cgiztjpmxmvz.cloudfront.net': 'backgrounds.wideo.co',
};

export const S3_PATH_STYLE_BASE = 'https://s3.amazonaws.com';

/**
 * Rewrites a CloudFront asset URL to a path-style S3 URL.
 * Virtual-hosted URLs ({bucket}.s3.amazonaws.com) are invalid for dotted bucket names (TLS cert mismatch).
 */
export function resolveCloudfrontToS3Url(src: string): string {
  if (!src) {
    return src;
  }
  try {
    const url = new URL(src);
    const bucket = CLOUDFRONT_TO_S3_BUCKET[url.hostname];
    if (!bucket) {
      return src;
    }
    return `${S3_PATH_STYLE_BASE}/${bucket}${url.pathname}${url.search}`;
  } catch {
    return src;
  }
}
